import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
    AbstractControl, ValidationErrors
} from "@angular/forms";
import { RoleService } from "@main/roles";
import { UserService } from "@main/users";
import { FormButtonsConfig } from "@mipro/components";
import { UserSuggestion } from "@project/models";
import { SharedFileService } from "@mipro/services/shared-file.service";
import { SelectItem } from "primeng/api";
import { UserHelperService } from "@main/users/user-helper.service";
import { FormioViewerService } from "@main/formio/services/formioViewer.service";
import { FormioDataViewerService } from "@main/formio/services/formioDataViewer.service";
import { Components } from "formiojs";
import form = Components.components.form;
import { ShareFormDataDTO } from "@main/formio/dto/shareFormDataDTO";
import { MultiSelectChangeEvent } from "primeng/multiselect";
import email = Components.components.email;
import { FormIoShareDialogService } from "@main/formio/components/formio-share-dialog/formio-share-dialog.service";

@Component({
    selector: "formio-share-dialog",
    templateUrl: "./formio-share-dialog.component.html",
    styleUrls: ["./formio-share-dialog.component.scss"]
})
export class FormIOShareDialogComponent {
    protected formIoShareDialogService = inject(FormIoShareDialogService);

    @Input() header: string = "Share file";

    shareFileFormButtonsConfig = <FormButtonsConfig>{
        cancelFunc: () => {
            this.formIoShareDialogService.close();
        },
        saveLabel: "Share"
    };
}